<template>
  <ImagePicker
    bg-color="white"
    :disable="disable"
    :model-value="imageUrl"
    :readonly="readonly"
    :revert="Boolean(!imageUrl && existingUrl)"
    :revert-tooltip="`Revert to saved ${assetTypeLower} image`"
    round
    :style="{ height: `${size}px`, width: `${size}px` }"
    :tooltip="`Choose ${existingUrl ? 'a new' : 'your own'} image for this ${assetTypeLower}.`"
    @clear="$emit('clear')"
    @revert="$emit('update:model-value', existingUrl)"
    @update:model-value="$emit('update:model-value', $event)"
  >
    <template #upload-message>
      <div v-if="existingUrl" class="row justify-center items-center text-no-wrap line-height-1">
        <q-icon name="cloud_upload" />
        <div class="q-mb-sm">Choose Image</div>
      </div>
      <VehicleDefaultImage v-else-if="isVehicleType" :size="size * 0.9" />
      <AssetDefaultImage v-else :size="size * 0.9" />
    </template>
  </ImagePicker>
</template>

<script setup lang="ts">
import _toLower from 'lodash/toLower';
import { computed } from 'vue';
import AssetDefaultImage from 'components/assets/AssetDefaultImage.vue';
import ImagePicker from 'components/ImagePicker.vue';
import VehicleDefaultImage from 'components/vehicle/VehicleDefaultImage.vue';
import { ASSET_TYPE_NAMES, ASSET_TYPES } from 'src/services/constants';

defineOptions({ name: 'AssetPicture' });

const props = withDefaults(
  defineProps<{
    disable?: boolean;
    imageUrl?: string | null;
    existingUrl?: string | null;
    readonly?: boolean;
    size?: number;
    type: string;
  }>(),
  {
    size: 128,
  }
);

defineEmits(['clear', 'update:model-value']);

const assetType = computed(() => ASSET_TYPE_NAMES[props.type]);
const assetTypeLower = computed(() => _toLower(assetType.value));
const isVehicleType = computed(() => props.type === ASSET_TYPES.VEHICLE);
</script>
